import { StorageNoSql } from '../core/storage-nosql.service'
export function storageNoSql_Provider(storage: StorageNoSql) {
    return ():Promise<any> => {
        return storage.init()
    }
}